/* eslint-disable array-callback-return */

import React from 'react';
import { EditorState, Modifier } from 'draft-js';
import {
  createEmptySelectionState,
  contentStateWithInsertedText,
  getContentStateWithAppliedEntity,
} from 'Shared/utils/draftJsHelpers';

import ImageAttachment from 'Shared/components/DraftEditor/components/ImageAttachment/ImageAttachment';
import { convertFileToBase64 } from 'Shared/helpers';

const IMAGE_ATTACHMENT_ANCHOR = ' ';
const IMAGE_ATTACHMENT_ENTITY_TYPE = 'IMAGE_ATTACHMENT';

const imageAttachmentPlugin = ({ handleImageAttachmentRemove, imageAttachmentFullWidth }) => ({
  decorators: [
    {
      strategy: (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges(character => {
          const entityKey = character.getEntity();
          return entityKey !== null && contentState.getEntity(entityKey).getType() === IMAGE_ATTACHMENT_ENTITY_TYPE;
        }, callback);
      },
      component: props => (
        <ImageAttachment
          imageAttachmentFullWidth={imageAttachmentFullWidth}
          onImageAttachmentRemove={handleImageAttachmentRemove}
          {...props}
        />
      ),
    },
  ],
});

// function addEntity(contentState, selection, entityType, data) {
//   const contentStateWithEntity = contentState.createEntity(entityType, 'IMMUTABLE', data);
//   const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
//   return contentStateWithAppliedEntity(contentState, selection, entityKey);
// }

function createFileEntity(editorState, entityData) {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  const blockKey = selectionState.getFocusKey();
  const blockOffset = selectionState.getFocusOffset();

  const selectionForAnchor = createEmptySelectionState(blockKey, blockOffset, blockOffset);
  const contenstStateWithAnchor = contentStateWithInsertedText(
    contentState,
    selectionForAnchor,
    `${IMAGE_ATTACHMENT_ANCHOR} `
  );

  const selectionStateForEntity = createEmptySelectionState(
    blockKey,
    blockOffset,
    blockOffset + IMAGE_ATTACHMENT_ANCHOR.length
  );
  const contentStateWithCreatedEntity = getContentStateWithAppliedEntity(
    contenstStateWithAnchor,
    selectionStateForEntity,
    IMAGE_ATTACHMENT_ENTITY_TYPE,
    entityData
  );

  return EditorState.push(editorState, contentStateWithCreatedEntity);
}

function removeImageAttachment(editorState, attachmentId) {
  const contentState = editorState.getCurrentContent();
  const contentBlocks = contentState.getBlocksAsArray();
  let entityInfo = {};
  contentBlocks.map(contentBlock => {
    let selectedEntity = null;
    contentBlock.findEntityRanges(
      character => {
        if (character.getEntity() !== null) {
          const entity = contentState.getEntity(character.getEntity());
          const entityType = entity.getType();
          const entityData = entity.getData();
          if (entityType === IMAGE_ATTACHMENT_ENTITY_TYPE && entityData.attachmentId === attachmentId) {
            selectedEntity = {
              entityKey: character.getEntity(),
              blockKey: contentBlock.getKey(),
              entity: contentState.getEntity(character.getEntity()),
            };
            return true;
          }
        }
        return false;
      },
      (start, end) => {
        entityInfo = { ...selectedEntity, start, end };
      }
    );
  });

  const selectionForReplaceAnchor = createEmptySelectionState(entityInfo.blockKey, entityInfo.start, entityInfo.end);
  const contentStateWithReplacedAnchor = Modifier.removeRange(contentState, selectionForReplaceAnchor);

  return EditorState.push(editorState, contentStateWithReplacedAnchor, 'apply-entity');
}

async function enrichEditorStateByImageAttachment(editorState, file, entityData = {}) {
  const base64String = await convertFileToBase64(file);
  if (!base64String) return editorState;

  const editorStateWithEntity = createFileEntity(editorState, {
    src: base64String,
    fileName: file.name,
    fileType: file.type,
    ...entityData,
  });
  return EditorState.moveFocusToEnd(editorStateWithEntity);
}

function monitorRemovingAttachmentEntity(editorState, { attachmentIds, removeAction }) {
  const contentState = editorState.getCurrentContent();
  const contentBlocks = contentState.getBlocksAsArray();
  const entityImageAttachmentIds = [];
  contentBlocks.map(contentBlock => {
    let entityImageAttachmentId = null;
    contentBlock.findEntityRanges(
      character => {
        if (character.getEntity() !== null) {
          const entity = contentState.getEntity(character.getEntity());
          const entityType = entity.getType();
          if (entityType === IMAGE_ATTACHMENT_ENTITY_TYPE) {
            const entityData = entity.getData();
            entityImageAttachmentId = entityData.attachmentId;
            return true;
          }
        }
        return false;
      },
      () => {
        entityImageAttachmentIds.push(entityImageAttachmentId);
      }
    );
  });
  const removedAttachmentIds = attachmentIds.filter(id => !entityImageAttachmentIds.includes(id));

  if (removedAttachmentIds.length) {
    removedAttachmentIds.forEach(attachmentId => removeAction(attachmentId));
  }

  return editorState;
}

export {
  enrichEditorStateByImageAttachment,
  removeImageAttachment,
  imageAttachmentPlugin,
  monitorRemovingAttachmentEntity,
};
